<template>
    <div>
        <app-multi-lang-input id="name"
                              v-model="form.name"
                              name="name"
                              rules="required"
                              :langs="locales && Object.keys(locales)">
            <template #label>
                {{ $t('Name') }}*
            </template>
        </app-multi-lang-input>
        <app-multi-lang-textarea id="comments"
                                 v-model="form.comments"
                                 name="comments"
                                 :langs="locales && Object.keys(locales)">
            <template #label>
                {{ $t('Comments') }}
            </template>
        </app-multi-lang-textarea>
        <app-upload input-class="form-control custom-gray-input-bg"
                    :max-size="maxMbSize"
                    :placeholder="$t('Click here to choose file')"
                    @size-exceeded="onSizeExceeded"
                    @remove="removeFile"
                    @file="onFile"/>
    </div>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
    name: 'AdditionForm',
    props: {
        form: Object
    },
    data() {
        return {
            maxMbSize: 10
        };
    },
    computed: {
        ...mapGetters(['locales'])
    },
    methods: {
        onFile(file) {
            this.form.img = file;
        },
        onSizeExceeded(size) {
            alert(`${this.$t('File size')} ${Math.round((size + Number.EPSILON) * 100) / 100}Mb ${this.$t('exceeds the limit of')} ${this.maxMbSize}Mb!`);
        },
        removeFile() {
            this.form.img = {};
        },
    }
};
</script>
